/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Site_Url_Error_Domain_DeniedInputs */

const en_site_url_error_domain_denied = /** @type {(inputs: Site_Url_Error_Domain_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This website cannot be dissected.`)
};

const id_site_url_error_domain_denied = /** @type {(inputs: Site_Url_Error_Domain_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Situs ini tidak bisa dibedah.`)
};

/**
* | output |
* | --- |
* | "This website cannot be dissected." |
*
* @param {Site_Url_Error_Domain_DeniedInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const site_url_error_domain_denied = /** @type {((inputs?: Site_Url_Error_Domain_DeniedInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Site_Url_Error_Domain_DeniedInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_site_url_error_domain_denied(inputs)
	return en_site_url_error_domain_denied(inputs)
});